import React from "react";
import { ModalTemplate } from "../../templates/ModalTemplate";
import { DetailBlogForm } from "../form/DetailBlogForm";
import { BlogDetailResponse } from "../../../core/api/requests/blog/detail/types";

type Props = {
    isOpen: boolean;
    onClose: () => void;
    blog: BlogDetailResponse;
};

export const DetailBlogModal: React.FC<Props> = ({ isOpen, onClose, blog }) => {
    return (
        <ModalTemplate
            isOpen={isOpen}
            title="Blog Details"
            onClose={onClose}
            maxWidth="800px"
        >
            <DetailBlogForm blog={blog} />
        </ModalTemplate>
    );
}; 